import { defineTemplate } from '../../../utils';

const CTV_BASE_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;
const CTV_PREVIEWS = `${CTV_BASE_URL}/previews/ctv`;
const CTV_THUMBNAILS = `${CTV_BASE_URL}/thumbnails`;

export const disneyCTV = defineTemplate({
  mode: 'legacy',
  id: 'ctv',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'CTV',
  thumbnail: {
    url: `${CTV_THUMBNAILS}/ctv.png`,
    optimizedUrl: `${CTV_THUMBNAILS}/optimized/ctv.png`,

    aspectRatio: 'horizontal'
  },
  previewByResolution: {
    '1920x1080': { kind: 'video', url: `${CTV_PREVIEWS}/ctv_1920x1080.mp4` },
    '1080x1350': { kind: 'video', url: `${CTV_PREVIEWS}/ctv_1080x1350.mp4` },
    '1080x1080': { kind: 'video', url: `${CTV_PREVIEWS}/ctv_1080x1080.mp4` },
    '300x250': { kind: 'video', url: `${CTV_PREVIEWS}/ctv_300x250.mp4` },
    '300x600': { kind: 'video', url: `${CTV_PREVIEWS}/ctv_300x600.mp4` }
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'description',
      label: 'Descripción',
      type: 'input',
      placeholder: 'Describí la serie o película',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'video',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/video.png'
    },
    {
      key: 'background',
      label: 'Imagen de fondo',
      type: 'image',
      placeholder: 'https://ejemplo.com/fondo.jpg',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/background.png'
    },
    {
      key: 'logo',
      label: 'Logo',
      type: 'image',
      placeholder: 'https://ejemplo.com/logo.png',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png'
    }
  ],
  promptTemplate:
    `Haceme un video CTV de "El Oso", usando este video "${process.env.REACT_APP_MEDIA_DOMAIN}/TESTDISNEY/examples/movies/12-the-bear.mp4"`
});
